export const SCHOOL_PAGE_COUNT = 30;